export default __webpack_public_path__ + "static/MediaContentThree-21cedecfabcf78353e36c803d6f77525.webp";